import type {PartGridRowModel} from "../CategorizationTableDataModel.ts";
import type {GridFilterOperator} from '@mui/x-data-grid';
import {DateBetweenFilterComponent} from "./DateBetweenFilterComponent.tsx";

export const dateBetweenFilter: GridFilterOperator<PartGridRowModel, Date> =
    {
        headerLabel: 'Date Between',
        label: 'Between',
        value: 'between',
        getApplyFilterFn: (filterItem) => {
            if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
                return null;
            }
            if (filterItem.value[0] == null && filterItem.value[1] == null) {
                return null;
            }
            return (value) => {
                return (
                    value !== null &&
                    (filterItem.value[0] == null || filterItem.value[0] <= value) &&
                    (filterItem.value[1] == null || value <= filterItem.value[1])
                );
            };
        },
        InputComponent: DateBetweenFilterComponent,
    };
